import create from "zustand";

interface MenuSidebarStoreState {
    shouldCloseDrawer: boolean;
}

export const useMenuSidebarStore = create<MenuSidebarStoreState>(() => ({
    shouldCloseDrawer: false,
}));
